class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;

         $.get(`/collections/recommendations?view=ajax&sort_by=manually`, function(data, status){
    var htmlss = $(data).filter('div[getHtml="true"]').html();
   $(".main-ajax-container").html(htmlss);
  });
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        console.log("debugjsc");
        //---------------Tiered Discount function------------------//
  function cart_data_renders() {
      $.get('/cart', function(data) {
          var data = new DOMParser().parseFromString(data, 'text/html');
          document.querySelector("table.cart-items").innerHTML = data.querySelector("table.cart-items").innerHTML;
          document.querySelector("p.totals__subtotal-value").innerHTML = data.querySelector("p.totals__subtotal-value").innerHTML;
          document.querySelector(".drawer .fs__i").innerHTML = data.querySelector(".drawer .fs__i").innerHTML;
      });
  }
function tieredDiscount() {
  $.getJSON("/cart.js", function(data) {
      //console.log(data);
      var checkGiftProduct = false;
      var checkLingerieProduct = false;
      data.items.forEach(function(p, i) {
          if (p.id == window.routes.free_gift_product) {console.log("dsd");
              checkGiftProduct = true;
              if (data.total_price > 7500) {
                  if (p.quantity > 1) {
                      jQuery.post('/cart/change.js', {
                          quantity: 1,
                          id: p.key
                      }, function(ds) {
                          cart_data_renders();
                      });
                  }
              } else {
                  jQuery.post('/cart/change.js', {
                      quantity: 0,
                      id: p.key
                  }, function(ds) {
                      cart_data_renders();
                  });

              }

          } else if (p.id == window.routes.freeLingreeProduct) { console.log("sdsdd");
              if (data.total_price > 10000) {
                  checkLingerieProduct = true;
                  if (p.quantity > 1) {
                      jQuery.post('/cart/change.js', {
                          quantity: 1,
                          id: p.key
                      }, function(ds) {
                          cart_data_renders();
                      });
                  }
              } else {
                  jQuery.post('/cart/change.js', {
                      quantity: 0,
                      id: p.key
                  }, function(ds) {
                      cart_data_renders();
                  });

              }
          }
      });
      setTimeout(function() {
          //if product is not added then add gift product
          if (!checkGiftProduct && data.total_price > 7500) {console.log("asasasA");
              //console.log("noooo");
              $.ajax({
                  type: "POST",
                  url: '/cart/add.json',
                  data: {
                      id: window.routes.free_gift_product,
                      quantity: 1
                  },
                  dataType: "jsonp",
                  success: function(response) {
                      // console.log(response);
                      cart_data_renders();
                  }
              });
          }
          if (!checkLingerieProduct && data.total_price > 10000) {console.log("assssssssssss");
              //    console.log("noooorrr");
              $.ajax({
                  type: "POST",
                  url: '/cart/add.json',
                  data: {
                      id: window.routes.freeLingreeProduct,
                      quantity: 1
                  },
                  dataType: "jsonp",
                  success: function(response) {
                      // console.log(response);
                      cart_data_renders();
                  }
              });
          }
      }, 1000);

  });
}
  //---------Tiered Discount function end------------------- //
//console.log(window.routes);
        tieredDiscount();
       $.get(`/cart?section_id=main-cart-items`, function(data, status){
    var freeShipping = $(data).find('.title-wrapper-with-links').html();
           if(freeShipping){
   $(".title-wrapper-with-links").html(freeShipping);             
           }
  });
          $.get(`/collections/recommendations?view=ajax&sort_by=manually`, function(data, status){
    var htmlss = $(data).filter('div[getHtml="true"]').html();
   $(".main-ajax-container").html(htmlss);
  });
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
      constructor() {
        super();

      this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, ON_CHANGE_DEBOUNCE_TIMER))
      }
  });
};
